import { render, staticRenderFns } from "./CaseEditImageForm.vue?vue&type=template&id=17398722&scoped=true&"
import script from "./CaseEditImageForm.vue?vue&type=script&lang=js&"
export * from "./CaseEditImageForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseEditImageForm.vue?vue&type=style&index=0&id=17398722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17398722",
  null
  
)

export default component.exports